import { ScreenDesignDocumentDto } from "@kuika/kuika-cl-model";
import { ScreenDesignDocumentService } from "../../../services/document-service";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface DocumentsProviderState {
  updateProjectDocumentsList: () => void;
  projectDocumentList: ScreenDesignDocumentDto[];
}

export class DocumentsProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  DocumentsProviderState
> {
  static defaultState: DocumentsProviderState = {
    updateProjectDocumentsList: () => {},
    projectDocumentList: []
  };

  getProviderValues = (): DocumentsProviderState => {
    return {
      updateProjectDocumentsList: this.updateProjectDocumentsList,
      projectDocumentList: this.state.projectDocumentList
    };
  };

  updateProjectDocumentsList = async () => {
    try {
      if (this.state.project?.id) {
        const res = await ScreenDesignDocumentService.GetAllByScreenDesignId(this.state.sdId);
        if (res && res.status === 200) {
          this.setState({ projectDocumentList: res.data });
        }
      }
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
    }
  };
}
